import { render } from "./HeaderItem.vue?vue&type=template&id=5208ef87&scoped=true"
import script from "./HeaderItem.vue?vue&type=script&lang=ts"
export * from "./HeaderItem.vue?vue&type=script&lang=ts"

import "./HeaderItem.vue?vue&type=style&index=0&id=5208ef87&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5208ef87"

export default script